import { WallboxDto } from '../api/dto/wallbox.dto'
import { WallboxModel } from '../models/wallbox-model'
import { getMidMeterStatus } from '../utils/get-mid-meter-status'
import { getTariff } from '../utils/get-tariff'
import { getTariffToDisplay } from '../utils/get-tariff-to-display'
import { TariffStatusType } from '../../shared/models/types'

/**
 * Function for transforming wallbox dto model to front-end model
 * @param wallbox - WallboxDto
 * @returns WallboxModel
 */
export const wallboxDtoToModel = (wallbox: WallboxDto): WallboxModel => {
  return {
    wallboxId: wallbox.wallboxId,
    wallboxName: wallbox.wallboxName,
    wallboxType: wallbox.wallboxType,
    tariffToDisplay: getTariffToDisplay(wallbox),
    activeTariff: wallbox.activeTariff ? getTariff(wallbox.activeTariff, TariffStatusType.active) : undefined,
    inactiveTariffs: wallbox.inactiveTariffs.map(tariff => {
      return getTariff(tariff, TariffStatusType.inactive)
    }),
    expiredTariffs: wallbox.expiredTariffs.map(tariff => {
      return getTariff(tariff, TariffStatusType.expired)
    }),
    midMeter: getMidMeterStatus(wallbox.useMidMeter, wallbox.pulseWeight),
    useMidMeter: wallbox.useMidMeter,
  }
}
